/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserVideoV2VideoScrollFramesInner } from './userVideoV2VideoScrollFramesInner';


export interface UserVideoV2VideoScroll { 
    /**
     * Base URL for scrolling frames
     */
    base_url?: string;
    frames?: Array<UserVideoV2VideoScrollFramesInner>;
}

